import {profile} from "./profile.js";
import { helpers } from '../helpers.js';

var woo = {
	selectors: {},
	addresses: [],
	addingToCart: false,
	isBookingProduct: false,
	BMDiscounts: false,
	bookingDates: false,
	bookingDatesFull: false,
	bookingCancelled: false,
	possibleQuantity: 0,

	init: function () {
		var self = this;

		self.updateHeaderCart();
		self.quantity();
		self.variationsImageChanger();
		self.cartUpsell();
		
		self.isBookingProduct = ( typeof is_booking_module === 'undefined' ) ? false : is_booking_module;
		self.BMDiscounts = self.isBookingProduct ? booking_module_discounts : false;

		if( jQuery( '.product-preview' ).length ) {
			self.productPreview();
		}

		if( document.querySelector('.single_variation_wrap') ) {
			jQuery( '.single_variation_wrap' ).attr( 'data-totalstring', pctVars.l18n.total );
		}
		
		if( document.querySelector('.product-type-simple .product-price-wrapper p.price') ) {
			jQuery( '.product-type-simple .product-price-wrapper p.price' ).attr( 'data-totalstring', pctVars.l18n.total );
		}
		
		if( document.querySelector('.single-product .product-type-simple') ) {
			self.addToCart();
		}

		jQuery( document.body ).on( 'updated_cart_totals', function(){
			self.quantity();
		});

		var checkExist = setInterval(function() {
			if ( document.querySelector( '.variations_form .quantity-wrapper' ) ) {
				clearInterval( checkExist ); // Stop checking once .variations_form is found
				self.variations();
			}
		}, 100 ); // Check every 100ms

		self.loadProfileAddresses();

		jQuery( '.js-closeAddedToCard' ).on( 'click', function(){
			jQuery( '[data-fancybox-close]' ).click();
		});
	
		jQuery( '[data-cancelorder]' ).on( 'click', function(){
			if( jQuery( this ).hasClass( 'disabled' ) ) {
				return false;
			}

			const post_id = jQuery( this ).attr( 'data-cancelorder' );

			jQuery( this ).attr( 'disabled', 'disabled' );
			jQuery( this ).addClass( 'disabled' );

			helpers.pctApiCall({
				action: 'cancel_paid_order',
				post_id: post_id,
			}).then( response => {
				if( ! response.success ) {
					console.error( 'Error: ', response.data.message ); 
					return false;
				}
	
				// refresh page
				window.location.reload();
			}).catch(error => {
				console.error( 'Error: ', error); 
			});
		});

		if( self.isBookingProduct ) {
			self.checkBookingDate();

			if( ! jQuery( '.variations--fake' ) ) {
				return false;
			}

			const fakes = jQuery( '.variations--fake' );

			if( fakes.hasClass( 'variations--individual' ) ) {
				self.loadIndividualProductOptions();
			} else if( fakes.hasClass( 'variations--ticket' ) ){
				// nada
			} else{
				self.checkForSelectDate();
				self.loadBookingDates();
			}
		}

        jQuery(document).ready(function($) {
            const checkbox = $('input[name="billing_custom_checkbox"]');
            const newsletterPicker = $('.woocommerce-billing-fields .newsletter-picker');
            // console.log(checkbox);
            // console.log(newsletterPicker);

            if (checkbox.length && newsletterPicker.length) {
                checkbox.on('change', function() {
                    console.log("change");
                    if (checkbox.is(':checked')) {
                        newsletterPicker.removeClass('hidden');
                        // console.log("checked");
                    } else {
                        newsletterPicker.addClass('hidden');
                        // console.log("unchecked");
                    }
                });

                // Initial check
                if (!checkbox.is(':checked')) {
                    // console.log("hidden");
                    newsletterPicker.addClass('hidden');
                }
            }
        });

		// feed add to cart
		self.addToCartFromFeed();
		self.emptyCheckoutFields();
	},

	cartUpsell: function () {
		const self = this;
		
		jQuery( document ).on( 'click', '.js-cartUpsellAddToCart', function( event ){
			event.preventDefault();

			const thisbutton 	= jQuery( this );
			const prevText		= thisbutton.text();
			const product_id 	= parseInt( thisbutton.attr( 'data-product_id' ) );
			const variation_id 	= parseInt( thisbutton.attr( 'data-variant_id' ) );
			const product_qty 	= parseInt( thisbutton.closest( '.cart_item' ).find( '.quantity .qty' ).val() );

			if( product_qty == 0 ) {
				return false;
			}

			jQuery.ajax({
				type: 'post',
				url: wc_add_to_cart_params.ajax_url,
				data: {
					action: 'woocommerce_ajax_add_to_cart',
					product_id: product_id,
					product_sku: '',
					quantity: product_qty,
					variation_id: variation_id,
					add_as_null_price: false,
					booking_item_id: false,
					booking_item_additional_data: false,
				},
				beforeSend: function ( response ) {					
					thisbutton.text( pctVars.l18n.add_item_to_cart );
					thisbutton.removeClass( 'added' ).addClass('loading');
				},
				complete: function ( response ) {
					thisbutton.addClass('added').removeClass('loading');
					thisbutton.text( prevText );
					self.addingToCart = false;
				}, 
				success: function ( response ) { 
					if (response.error && response.message) {
						self.showErrorMessage( response.message );
					} else {
						self.do_updateHeaderCart( response );

						if( jQuery( 'body' ).hasClass( 'woocommerce-checkout' ) ) {
							location.reload();
						}
					} 
				}, 
			});
		});

		jQuery( document ).on( 'change', '.cart-upsell .quantity input.qty', function(){
			const productPrice 	= parseFloat( jQuery( this ).closest( '.cart_item' ).find( '.per-item-price' ).html() );
			const totalPrice 	= jQuery( this ).closest( '.cart_item' ).find( '.per-item-total-price' );
			const qty 			= parseInt( jQuery( this ).closest( '.cart_item' ).find( '.quantity .qty' ).val() );

			totalPrice.html( productPrice * qty );
		});
	},

    variationsImageChanger: function () {
        let thumbnailFigureNodes = document.querySelectorAll('.product-gallery__thumbnails figure');

        if (! thumbnailFigureNodes.length) {
            return false;
        }

        thumbnailFigureNodes.forEach((figure) => {
            figure.addEventListener('click', () => {
                let figureID = figure.dataset.imageId;
                let galleryFigureToOpen = document.querySelector('.product-gallery__inner figure[data-image-id="' + figureID + '"] a');
                galleryFigureToOpen.click();
            });
        });

        let variationsFormNode = document.querySelector('.variations_form');
        let articleGalleryThumbnailNode = document.querySelector('.product-gallery__thumbnails');

        if (! variationsFormNode || ! articleGalleryThumbnailNode) {
            return false;
        }

        let thumbnails = articleGalleryThumbnailNode.querySelectorAll('figure');

        if (! thumbnails.length) {
            return false;
        }

        jQuery('.woo-variation-raw-select').on('change', function (ev) {
            thumbnails.forEach((thumbnail) => {
                if (thumbnail.dataset.variant === ev.target.value) {
                    thumbnail.style.display = 'block';
                } else {
                    thumbnail.style.display = 'none';
                }
            });
        });
    },

	productPreview: function() {
		const self = this;

		self.countdownElement 	= document.querySelector('.countdown');
		self.targetDateStr 		= self.countdownElement.getAttribute('data-date');
		self.newtargetDateStr 	= self.countdownElement.getAttribute('data-dateend');

		self.targetDate 		= new Date(self.parseDate(self.targetDateStr)).getTime();
		self.newtargetDate 		= new Date(self.parseDate(self.newtargetDateStr)).getTime();
		self.countdownInterval 	= setInterval(function() { self.startCountdown(); }, 1000);
	},

		startCountdown: function() {
			const self = this;

			const now 			= new Date().getTime();
			const distance 		= self.targetDate - now;
			const newdistance 	= self.newtargetDate - now;
		
			let days 	= Math.floor(distance / (1000 * 60 * 60 * 24));
			let hours 	= Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
			let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
			let seconds = Math.floor((distance % (1000 * 60)) / 1000);
		
			if ( distance > 0 ) {
				jQuery( '.js-beforeStartMessage' ).removeClass( 'd-none' );
			}

			if (distance <= 0) {	
				jQuery( '.product-preview .button' ).removeClass( 'disabled' );
			
				days = Math.floor(newdistance / (1000 * 60 * 60 * 24));
				hours = Math.floor((newdistance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
				minutes = Math.floor((newdistance % (1000 * 60 * 60)) / (1000 * 60));
				seconds = Math.floor((newdistance % (1000 * 60)) / 1000);
			}

			if( distance <= 0 && newdistance > 0 ) {
				jQuery( '.js-beforeEndMessage' ).removeClass( 'd-none' );
			}

			if( newdistance <= 0 ) {
				clearInterval(self.countdownInterval);

				jQuery(".countdown").addClass("d-none");
				jQuery(".js-countdownEndMessage").removeClass("d-none");
				jQuery(".product-preview .button").addClass("d-none");

				return true;
			}
		
			document.getElementById("days").innerHTML = self.timeName(days, "days");
			document.getElementById("hours").innerHTML = self.timeName(hours, "hours");
			document.getElementById("minutes").innerHTML = self.timeName(minutes, "minutes");
			document.getElementById("seconds").innerHTML = self.timeName(seconds, "seconds");
		},

		timeName: function(number, type) {
			const self = this;

			switch (type) {
			  case 'seconds':
				return self.timeNameLimit(number, pctVars.l18n.time.seconda, pctVars.l18n.time.secondy, pctVars.l18n.time.second);
			  case 'minutes':
				return self.timeNameLimit(number, pctVars.l18n.time.minuta, pctVars.l18n.time.minuty, pctVars.l18n.time.minut);
			  case 'hours':
				return self.timeNameLimit(number, pctVars.l18n.time.houra, pctVars.l18n.time.houry, pctVars.l18n.time.hour);
			  case 'days':
				return self.timeNameLimit(number, pctVars.l18n.time.day, pctVars.l18n.time.dayy, pctVars.l18n.time.dayu);
			  default:
				return '';
			}
		},

		parseDate: function(dateString) {
			return dateString.replace(' ', 'T');
		},
		
		timeNameLimit: function(number, one_type, two_four_type, others_type) {
			const self = this;

			if (number === 1) {
				return `${number} <span>${one_type}</span>`;
			} else if (number >= 2 && number <= 4) {
				return `${number} <span>${two_four_type}</span>`;
			} else {
				return `${number} <span>${others_type}</span>`;
			}
		},

	emptyCheckoutFields: function() {
		if( ! jQuery( '.woocommerce-checkout--emptyfields' ) ) {
			return false;
		}

		const wb = '.woocommerce-checkout--emptyfields .woocommerce-billing-fields__field-wrapper';
		const ws = '.woocommerce-checkout--emptyfields .woocommerce-shipping-fields__field-wrapper';
		const it = 'input[type="text"]';
		const ie = 'input[type="email"]';
		const ip = 'input[type="tel"]';

		jQuery( `${wb} ${it}, ${wb} ${ie}, ${wb} ${ip}` ).val( '' );
		jQuery( `${ws} ${it}, ${ws} ${ie}, ${ws} ${ip}` ).val( '' );
	},

	loadIndividualProductOptions: function() {
		const self = this;
		self.pattern = /^\d+-\d+$/;

		jQuery( '[name="individual_lang_type_list"]' ).on( 'change', function(){
			let value = jQuery( this ).val().split( '_' )[0];
			jQuery( '#pa_lang_groups' ).val( `${value}_group` ).trigger( 'change' );

			jQuery( '[name="quantity"]' ).val(1);
		});

		let addedGrouped = false;
		jQuery('#pa_group_type option').each(function () {
			var optionValue = jQuery(this).attr('value');
			var optionText = jQuery(this).text();

			// Check if option value matches the pattern "%d-%d"
			if (!self.pattern.test(optionValue) && optionValue !== "") {
				var radioButton = `<label><input type="radio" name="individual_price_type[]" value="${optionValue}"><span>${optionText}</span></label>`;
				jQuery('.individual-radio-boxes').append(radioButton);
			}

			if (!addedGrouped && self.pattern.test(optionValue)) {
				var radioButton = `<label><input type="radio" name="individual_price_type[]" value="grouped-default"><span>${pctVars.l18n.booking.grouped}</span></label>`;
				jQuery('.individual-radio-boxes').append(radioButton);

				addedGrouped = true;
			}
		});

		jQuery( '.individual-radio-boxes label:first-child [name="individual_price_type[]"]' ).attr( 'checked', 'checked' ).trigger('change');

		jQuery('.individual-radio-boxes').removeClass( 'd-none' );

		jQuery( '#pa_group_type' ).parent().prepend(`
			<div class="quantity-wrapper has-init quantity-wrapper--individual-group"><span class="quantity-wrapper__content">
				<button type="button" class="button button--small button--secondaryGhost qty-minus disabled" data-sikmon="collapseMinus"></button>
				<div class="quantity">
					<label class="screen-reader-text" for="quantity_individual_group_size"></label>
					<input type="number" id="quantity_individual_group_size" class="input-text qty text" name="qty-custom" value="1" min="1" max="2" step="1" placeholder="" inputmode="numeric" autocomplete="off">
				</div>
				<button type="button" class="button button--small button--secondaryGhost qty-plus" data-sikmon="expandPlus"></button>
			</span></div>
		`);

		jQuery( '.quantity-wrapper--individual-group button' ).on( 'click', function(){
			var quantityInput = jQuery(this).closest('.quantity-wrapper__content').find('.quantity input');
			var currentValue = parseInt(quantityInput.val());
			var min = parseInt(quantityInput.attr('min'));
			var max = parseInt(quantityInput.attr('max'));

			if (jQuery(this).hasClass('qty-minus')) {
				if (currentValue > min) {
					quantityInput.val(currentValue - 1).trigger('change');
					self.individualCheckForVariant();
				}
			} else if (jQuery(this).hasClass('qty-plus')) {
				if (currentValue < max) {
					quantityInput.val(currentValue + 1).trigger('change');
					self.individualCheckForVariant();
				}
			}
		});

		jQuery('#quantity_individual_group_size').on('change', function() {
			self.individualQuantityButtons( jQuery( this ) );
		});

		// Initialize the state of the buttons on page load
		self.individualQuantityButtons( jQuery( '#quantity_individual_group_size' ) );
		self.setIndividualQuantityButtonsValues();

		jQuery( '.individual-radio-boxes input[name="individual_price_type[]"]' ).on( 'change', function(){
			var radioValue = jQuery(this).attr('value');

			if( radioValue === "" ) {
				return false;
			}

			if ( radioValue == 'grouped-default' ) {
				jQuery( '.quantity-wrapper--individual-group button' ).removeClass( 'disabled' );

				jQuery( '#pa_group_type option' ).each(function() {
					var optionValue = jQuery(this).attr('value');
					
					if ( ! self.pattern.test( optionValue ) ) {
						return;
					}

					jQuery('#pa_group_type').val( optionValue ).trigger('change');
					return false;
				});

				setTimeout(function(){
					self.setIndividualQuantityButtonsValues();
				}, 100 );

				return false;
			}

			jQuery( '#pa_group_type' ).val( radioValue ).trigger('change');
			jQuery( '.quantity-wrapper--individual-group button' ).addClass( 'disabled' );
			jQuery( '#quantity_individual_group_size' ).val( booking_module_group_quantity[ radioValue ] );
		});

		// Preselect the first item in the dropdown for the time select field
		const timeSelect = document.querySelector('select[name="individual_time"]');
		const time_result = self.filterPastTimes( timeSelect );

		// Preselect the current date for the date input field
		const dateInput = document.querySelector('input[name="individual_date"]');

		if (! dateInput) {
			return false;
		}

		const future_days = time_result[1] === true ? 2 : 1;

		// Initial dates
		let initialStartDate = moment().add( future_days, 'day' );
		let initialEndDate 	 = moment().add( 1, 'year' );

		helpers.initializeDateRangePicker( 
			'[name="individual_date"]', 
			initialStartDate, 
			initialEndDate,
			initialStartDate,
			{
				singleDatePicker: true,
				autoApply: true,
				isInvalidDate: function(date) {
					const disabled = disabled_individual_dates;
					return disabled.includes( date.format( 'YYYY-MM-DD' ) );
				}
			}
		);

		self.fillSelectOption();

		jQuery('input[name="individual_date"], select[name="individual_time"]').on('change', function() {
			self.fillSelectOption();
		});
		
		jQuery('input[name="individual_date"]').on('change', function() {
			if( jQuery( this ).val() == initialStartDate.format( 'DD. MM. YYYY' ) ) {
				self.filterPastTimes( timeSelect );
			} else {
				self.filterPastTimes( timeSelect, true );
			}
		});
	},

		individualCheckForVariant: function() {
			const QIGS = jQuery( '#quantity_individual_group_size' );
			const value = QIGS.val();

			jQuery( '#pa_group_type option' ).each(function() {
				var optionValue = jQuery(this).val();

				if (! optionValue || optionValue === "" ) {
					return;
				}

				var range = optionValue.split('-');

				if (range.length !== 2) {
					return;
				}

				var min = parseInt(range[0]);
				var max = parseInt(range[1]);
				
				if (value >= min && value <= max) {
					jQuery('#pa_group_type').val(optionValue);
					

					setTimeout(function(){
						jQuery('#pa_group_type').trigger( 'change' );
					}, 50 );

					return false; // Break the loop
				}
			});
		},

		setIndividualQuantityButtonsValues: function() {
			const self = this;

			let min = 999;
			let max = 0;

			jQuery( '#pa_group_type option' ).each(function() {
				var optionValue = jQuery(this).attr('value');

				if ( ! self.pattern.test( optionValue ) ) {
					return;
				}

				const tmpMin = parseInt( optionValue.split( '-' )[0] );
				const tmpMax = parseInt( optionValue.split( '-' )[1] );

				if( tmpMin < min ) min = tmpMin;
				if( tmpMax > max ) max = tmpMax;
			});

			if( min > max ) {
				jQuery( '.quantity-wrapper--individual-group button' ).addClass( 'disabled' );
				jQuery( '#quantity_individual_group_size' ).val( booking_module_group_quantity[ jQuery( '#pa_group_type' ).val() ] );

				return false;
			}
			
			jQuery( '#quantity_individual_group_size' ).val( min );
			jQuery( '#quantity_individual_group_size' ).attr( 'min', min );
			jQuery( '#quantity_individual_group_size' ).attr( 'max', max );

			self.individualQuantityButtons( jQuery( '#quantity_individual_group_size' ) );
		},

		individualQuantityButtons: function(quantityInput) {
			var min = parseInt(quantityInput.attr('min'));
			var max = parseInt(quantityInput.attr('max'));
			var currentValue = parseInt(quantityInput.val());

			var minusButton = quantityInput.closest('.quantity-wrapper__content').find('.qty-minus');
			var plusButton = quantityInput.closest('.quantity-wrapper__content').find('.qty-plus');

			if (currentValue <= min) {
				minusButton.addClass('disabled');
			} else {
				minusButton.removeClass('disabled');
			}

			if (currentValue >= max) {
				plusButton.addClass('disabled');
			} else {
				plusButton.removeClass('disabled');
			}
		},

		fillSelectOption: function() {
			// Get the current selected/entered values from the date and time fields
			var date = jQuery('input[name="individual_date"]').val();
			date = moment( date, 'DD. MM. YYYY' ).format( 'YYYY-MM-DD' );

			var time = jQuery('select[name="individual_time"]').find('option:selected').text();

			// Combine the date and time into a single string
			var combinedDateTime = date + ' ' + time;

			// Update the first option of the booking module date select element
			jQuery('#booking_module_date option:first').val(combinedDateTime).text(combinedDateTime);
		},

		filterPastTimes: function( timeSelect, allow_all = false ) {
			const now = new Date();
			const currentHour = now.getHours();
			const currentMinute = now.getMinutes();
			let counter = 0;
			let isEmpty	= false;
	
			for (let i = 0; i < timeSelect.options.length; i++) {
				const [hour, minute] = timeSelect.options[i].value.split(':').map(Number);
	
				if (hour < currentHour || ( hour === currentHour && minute <= currentMinute ) ) {
					timeSelect.options[i].style.display = 'none';
				} else {
					timeSelect.options[i].style.display = 'block';
					counter++;
				}
			}

			if( counter == 0 || allow_all ) {
				isEmpty = true; // move a day

				for (let i = 0; i < timeSelect.options.length; i++) {
					timeSelect.options[i].style.display = 'block';
				}
			}
	
			// Preselect the first visible item in the dropdown
			for (let i = 0; i < timeSelect.options.length; i++) {
				if (timeSelect.options[i].style.display !== 'none') {
					timeSelect.selectedIndex = i;
					break;
				}
			}

			return [ timeSelect.options.length, isEmpty ];
		},

	checkForSelectDate: function() {
		const self = this;

		const quantitySelector 	= document.querySelector( '.quantity-wrapper' );
		const getProductWrap 	= quantitySelector.closest( '.product.type-product' );
		const isSimpleProduct 	= getProductWrap.classList.contains( 'product-type-simple' );
		const isVariableProduct	= getProductWrap.classList.contains( 'product-type-variable' );
		// const currentValue		= jQuery( '#booking_module_date' ).find( ':selected' ).val();

		setTimeout(function(){
			self.disableQuantity();
			self.disableAddToCart();
		}, 150 );
	
		jQuery( '#booking_module_date' ).on( 'change', function( item ) {
			let value 		= jQuery( this ).find( ':selected' ).val();
			let productItem = false;
			const limits 	= JSON.parse( jQuery( this ).attr( 'data-bookinglimits' ) );
			const countItem	= jQuery( this ).parent().find( "p [data-count]" );

			// RESET QUANT

			jQuery( '[name="quantity"]' ).val(1);
			if( isSimpleProduct ) self.simpleProductUpdatePrices( getProductWrap, 1 );
			if( isVariableProduct ) self.variableProductUpdatePrices( getProductWrap, 1 );

			if( value == '' || value == null ) {
				self.disableQuantity();
				self.disableAddToCart();
				countItem.attr( 'data-count', 0 );

				return false;
			}

			jQuery.each( self.bookingDates, function(key, item) {
				if( item[ 'id' ] == value ) {
					productItem = limits[ key ];
				}
			});
			
			if( ! productItem ) {
				countItem.attr( 'data-count', 0 );
				return false;
			}

			countItem.attr( 'data-count', productItem.capacity );

			jQuery( '[name="quantity"]' ).attr( 'max', productItem[ 'capacity' ] );

			self.enableAddToCart();
			self.enableQuantity( 'plus' );
			self.disableQuantity( 'minus' );

			self.updatePossibleQuantity();
		});
	},

		disableAddToCart: function() {
			jQuery( '.single_add_to_cart_button' ).attr( 'disabled', 'disabled' );
			jQuery( '.single_add_to_cart_button' ).addClass( 'disabled' );
		}, 
		
		enableAddToCart: function() {
			jQuery( '.single_add_to_cart_button' ).removeAttr( 'disabled' );
			jQuery( '.single_add_to_cart_button' ).removeClass( 'disabled' );
		}, 
		
		disableQuantity: function( type = '' ) {
			let addClass = type == '' ? '' : `.qty-${type}`;
			jQuery( `.quantity-wrapper .button${addClass}` ).addClass( 'disabled' );
		}, 
		
		enableQuantity: function( type = '' ) {
			let addClass = type == '' ? '' : `.qty-${type}`;
			jQuery( `.quantity-wrapper .button${addClass}` ).removeClass( 'disabled' );
		}, 

	loadBookingDates: function() {
		const self = this;

		if( self.bookingDates ) {
			self.loadBookingDatesIntoSelect();
		}

		if( jQuery( '.variations--fake' ).length == 0 ) {
			return false;
		}

		const product_id = jQuery( '.variations--fake' ).attr( 'data-prid' );

		helpers.pctApiCall({
			action: 'booking_module_load_date',
			post_id: product_id,
		}).then( response => {
			if( ! response.success ) {
				console.error( 'Error: ', response.data.message ); 
				return false;
			}

			console.log( response );

			self.bookingDatesFull = response.data.is_full;
			self.bookingDates = response.data.options;
			self.bookingCancelled = response.data.cancelled;
			self.loadBookingDatesIntoSelect();			
		}).catch(error => {
			console.error( 'Error: ', error); 
		});
	},

		loadBookingDatesIntoSelect: function() {
			const self = this;

			if( self.bookingCancelled ) {
				helpers.showMessage( `<p><span data-sikmon="bookDate"></span> ${pctVars.l18n.booking.cancelled}</p>`, '.article-head__excerpt', 'date-alert mt-3', false, 'after' );
				return false;
			}

			if( self.bookingDatesFull && self.bookingDates === null ) {
				helpers.showMessage( `<p><span data-sikmon="bookDate"></span> ${pctVars.l18n.booking.tobe}</p>`, '.article-head__excerpt', 'date-alert mt-3', false, 'after' );
				return false;
			}

			if( self.bookingDatesFull ) {
				helpers.showMessage( `<p><span data-sikmon="bookDate"></span> ${pctVars.l18n.booking.sold_out}</p>`, '.article-head__excerpt', 'date-alert mt-3', false, 'after' );
				return false;
			}
			
			/* if( self.bookingDates === null ) {
				helpers.showMessage( `<p><span data-sikmon="bookDate"></span> ${pctVars.l18n.booking.no_terms}</p>`, '.article-head__excerpt', 'date-alert mt-3', false, 'after' );
				return false;
			} */

			jQuery.each( self.bookingDates, function(key, value) {
				var newOption = jQuery( '<option>', {
					value: value.id,
					text: value.text,
					class: 'attached enabled'
				});

				jQuery( '#booking_module_date' ).append( newOption );
			});

			jQuery( '#booking_module_date' ).attr( 'data-bookinglimits', JSON.stringify( self.bookingDates ) );

			if( Object.keys( self.bookingDates ).length >= 1 ) {
				jQuery( '#booking_module_date' ).prop( 'selectedIndex', 1 ).trigger( 'change' );
			}
		},

	variations: function() {
		const self = this;

		self.quantity();
		self.addToCart();

		const quantitySelector 	= document.querySelector( '.quantity-wrapper' );
		const getProductWrap 	= quantitySelector.closest( '.product.type-product' );

		jQuery( '.single_variation_wrap' ).on( 'show_variation', function( event, variation ) {
			self.quantity();
			self.addToCart();
			// self.updatePossibleQuantity();
			// self.updateVaritionPrice();
		});
		
		jQuery( '.variations_form' ).on( 'change', '.variations select', function( event, variation ) {
			if( jQuery( '.variations--individual' ) ) {
				return false;
			}

			self.updatePossibleQuantity();

			jQuery( '[name="quantity"]' ).val(1);
			self.variableProductUpdatePrices( getProductWrap, 1 );
		});
	},

		updatePossibleQuantity: function() {
			const self 			= this;

			if( typeof booking_module_group_quantity == 'undefined' ) {
				return false;
			}

			// disable on individial
			if( jQuery( '.variations--individual' ) ) {
				return false;
			}

			const dateSelect 	= jQuery( '#booking_module_date' );
			const limits 		= JSON.parse( dateSelect.attr( 'data-bookinglimits' ) );
			const value 		= dateSelect.find( ':selected' ).val();
			let productItem		= [];

			if( value == '' ) {
				return false;
			}

			limits.forEach(function( item, key ) {
				if( item[ 'id' ] == value ) {
					productItem = limits[ key ];
				}
			});

			jQuery( '.woocommerce-variation.single_variation' ).removeClass( 'd-none' );
			jQuery( '.woocommerce-variation-add-to-cart' ).removeClass( 'woocommerce-variation-add-to-cart-disabled' );
			self.enableAddToCart();

			Object.keys(booking_module_group_quantity).forEach(function( index ){
				// console.log( 'yeaaah' );

				if( ! jQuery( `input[data-value="${index}"]` ) ) return;
				if( ! jQuery( `input[data-value="${index}"]` ).is( ':checked' ) ) return;
				if( parseInt( booking_module_group_quantity[ index ] ) == 1 ) return;

				self.possibleQuantity = Math.floor( parseInt( productItem.capacity ) / parseInt( booking_module_group_quantity[ index ] ) );
				// console.log( self.possibleQuantity );

				if( self.possibleQuantity == 0 ) {
					jQuery( '.woocommerce-variation.single_variation' ).addClass( 'd-none' );
					jQuery( '.woocommerce-variation-add-to-cart' ).addClass( 'woocommerce-variation-add-to-cart-disabled' );
					self.disableAddToCart();
					return false;
				}

				return false;
			});

			self.possibleQuantity = parseInt( value ) * false;
		},

	updateHeaderCart: function() {
		var self = this;

		jQuery.ajax({
			type: 'post',
			url: wc_add_to_cart_params.ajax_url,
			data: {
				action: 'update_header_cart',
			},
			success: function ( response ) { 
				self.do_updateHeaderCart( response );
			}, 
		});
	},

		do_updateHeaderCart: function( response ) {
			let header_carts = document.querySelectorAll('.header-cart');

			if (!header_carts.length) {
				return false;
			}

			  

			let count = response.count;
			header_carts[0].setAttribute('data-count', count);
			if( header_carts.length > 1){
				header_carts[1].setAttribute('data-count', count);
			}

			header_carts.forEach(header_cart => {
				header_cart.parentElement.innerHTML += response.fragments['div.widget_shopping_cart_content'];
			});
			  


			if( document.querySelector( 'body' ).classList.contains( 'woocommerce-cart' ) && count == 0 ) {
				return false;
			}

			let free_shpping = response.free_shpping;

			if( free_shpping != '' ) {
				document.querySelector( '.added-to-cart-modal__shipping-free p' ).innerHTML = free_shpping;
				document.querySelector( '.added-to-cart-modal__shipping-free' ).classList.remove( 'd-none' );
			}
			
			jQuery( document.body ).trigger( 'added_to_cart', [ response.fragments, response.cart_hash ] );
		},

		openAddedToCart: function( response ) {
			document.querySelector( '.added-to-cart-modal__inner' ).innerHTML = response.fragments[ 'div.widget_shopping_cart_content' ];

			jQuery.fancybox.open({
				src  : '.added-to-cart-modal', // Selector to the modal content container
				type : 'inline', // Content type
				touch: false,
				/* opts : {
					afterShow : function(instance, current) {
						
					} 
				} */
			});
		},

	addToCart: function() {
		var self = this;

		jQuery( '.single_add_to_cart_button' ).on('click', function(e){ 
			e.preventDefault();

			if( self.addingToCart ) {
				return false;
			}

			self.removeErrorMessages(); // remove errors if any

			self.addingToCart = true;

			const thisbutton 	= jQuery( this );
			const prevText		= thisbutton.text();
			const form 			= thisbutton.closest('form.cart');
			const id			= thisbutton.val();
			const product_qty 	= form.find('input[name=quantity]').val() || 1;
			const product_id 	= form.find('input[name=product_id]').val() || id;
			const variation_id 	= form.find('input[name=variation_id]').val() || 0;

			/* BOOKING MODULE */
			let booking_item_id = ! jQuery( '.variations--fake' ).length ? false : jQuery( '#booking_module_date' ).find( ':selected' ).val();
			let booking_item_additional_data = {};

			if( jQuery( '.variations--individual' ) ) {
				booking_item_additional_data = {
					'lang': jQuery( '[name="individual_lang_type_list"]' ).find(":selected").val(),
					'group_type': jQuery( '#pa_group_type' ).find(":selected").val(),
					'size': jQuery( '#quantity_individual_group_size' ).val(),
				};
			}

			jQuery.ajax({
				type: 'post',
				url: wc_add_to_cart_params.ajax_url,
				data: {
					action: 'woocommerce_ajax_add_to_cart',
					product_id: product_id,
					product_sku: '',
					quantity: product_qty,
					variation_id: variation_id,
					add_as_null_price: thisbutton.hasClass( 'add-as-null-price' ),
					booking_item_id: booking_item_id,
					booking_item_additional_data: booking_item_additional_data,
				},
				beforeSend: function ( response ) {					
					thisbutton.text( pctVars.l18n.add_item_to_cart );
					thisbutton.removeClass( 'added' ).addClass('loading');
				},
				complete: function ( response ) {
					thisbutton.addClass('added').removeClass('loading');
					thisbutton.text( prevText );
					self.addingToCart = false;
				}, 
				success: function ( response ) { 
					if (response.error && response.message) {
						self.showErrorMessage( response.message );
					} else {
						if( thisbutton.hasClass( 'button--secondaryGhost' ) ) {
							if( document.querySelector( 'body' ).classList.contains( 'woocommerce-cart' ) ) {
								self.resetForm();
								return false;
							}

							window.location = pctVars.checkout_url;
							return false;
						}

						self.do_updateHeaderCart( response );
						self.openAddedToCart( response );
						self.resetForm();
					} 
				}, 
			}); 
		});
	},

	resetForm: function() {
		var self = this;
		
		jQuery( '[name="quantity"]' ).val(1);
		self.disableQuantity( 'minus' );
	},
	
	addToCartFromFeed: function() {
		var self = this;

		if( ! jQuery( '[data-custom_add_to_cart]' ) ) {
			return false;
		}

		jQuery( '[data-custom_add_to_cart]' ).on( 'click', function( event ){
			event.preventDefault();

			if( self.addingToCart ) {
				return false;
			}

			self.removeErrorMessages(); // remove errors if any

			self.addingToCart = true;
			
			const thisbutton 	= jQuery( this );
			const prevText		= thisbutton.text();
			const product_id 	= thisbutton.attr( 'data-productid' );

			jQuery.ajax({
				type: 'post',
				url: wc_add_to_cart_params.ajax_url,
				data: {
					action: 'woocommerce_ajax_add_to_cart',
					product_id: product_id,
					product_sku: '',
					quantity: 1,
					variation_id: 0,
					add_as_null_price: false,
					booking_item_id: false,
				},
				beforeSend: function ( response ) {					
					thisbutton.text( pctVars.l18n.add_item_to_cart );
					thisbutton.removeClass( 'added' ).addClass( 'loading' );
				},
				complete: function ( response ) {
					thisbutton.addClass( 'added' ).removeClass( 'loading' );
					thisbutton.text( prevText );
					self.addingToCart = false;
				}, 
				success: function ( response ) { 
					if (response.error && response.message) {
						self.showErrorMessage( response.message );
					} else {
						self.do_updateHeaderCart( response );
						self.openAddedToCart( response );
					} 
				}, 
			}); 
		});
	},

		showErrorMessage: function( message ) {
			const self = this;

			helpers.showMessage( message, '.woo-error-add-to-cart', 'woo-error-add-to-cart__item', true );

			/* const id = "id" + Math.random().toString(16).slice(2);

			jQuery( '.woo-error-add-to-cart' ).append(
				`<div id="${id}" class="woo-error-add-to-cart__item"><p>${message}</p><a href="#" data-sikmon="closeDelete"></a></div>`
			);

			jQuery( `#${id} a` ).on( 'click', function(){
				jQuery( `#${id}` ).remove();
			}); */
		},

	removeErrorMessages: function(){
		const self = this;

		jQuery( '.woo-error-add-to-cart' ).empty();
	},

	updateVaritionPrice: function() {
		const self = this;

		if( ! document.querySelector( '.woocommerce-variation.single_variation' ) ) {
			return;
		}

		const finalPrice = document.querySelector( '.woocommerce-variation.single_variation .woocommerce-variation-price > .price' ).innerHTML;
		document.querySelectorAll( '[data-maybeprice]' ).forEach(( item ) => {
			item.innerHTML = finalPrice;
		});
	},

	quantity: function () {
		var self = this;

		if( document.querySelectorAll( '.quantity-wrapper' ).length == 0 ) {
			return false;
		}

		const isCartPage = document.querySelector( 'body' ).classList.contains( 'woocommerce-cart' );

		document.querySelectorAll( '.quantity-wrapper:not( .has-init )' ).forEach(( quantitySelector ) => {
			quantitySelector.classList.add( 'has-init' );

			const quantityInput 	= quantitySelector.querySelector( 'input.qty' );
			const plusButton 		= quantitySelector.querySelector( '.qty-plus' );
			const minusButton 		= quantitySelector.querySelector( '.qty-minus' );
			const getProductWrap 	= ( ! isCartPage ) ? quantitySelector.closest( '.product.type-product' ) : quantitySelector.closest( '.cart_item' );
			const isSimpleProduct 	= getProductWrap.classList.contains( 'product-type-simple' );
			const isVariableProduct	= getProductWrap.classList.contains( 'product-type-variable' );
	
			if( ! quantityInput || ! plusButton || ! minusButton ) {
				return;
			}

			// Increment the value
			plusButton.addEventListener('click', () => {
				let currentValue = parseInt(quantityInput.value);
				let maxValue = quantityInput.getAttribute('max') ? parseInt(quantityInput.getAttribute('max')) : Infinity;

				if (currentValue < maxValue) {
					quantityInput.value = currentValue + 1;
				}

				if( quantityInput.value == maxValue ) {
					plusButton.classList.add( 'disabled' );
				}

				if( quantityInput.value <= maxValue ) {
					minusButton.classList.remove( 'disabled' );
				}

				quantityInput.dispatchEvent(new Event('change', { bubbles: true }));

				if( isSimpleProduct ) self.simpleProductUpdatePrices( getProductWrap, quantityInput.value );
				if( isVariableProduct ) self.variableProductUpdatePrices( getProductWrap, quantityInput.value );

				if( isCartPage ) {
					self.updateCart();
				}
			});
		
			// Decrement the value
			minusButton.addEventListener('click', () => {
				let currentValue = parseInt(quantityInput.value);
				let minValue = quantityInput.getAttribute('min') ? parseInt(quantityInput.getAttribute('min')) : 0;

				if (currentValue > minValue) {
					quantityInput.value = currentValue - 1;
				}

				if( quantityInput.value == minValue ) {
					minusButton.classList.add( 'disabled' );
				}
				
				if( quantityInput.value >= minValue ) {
					plusButton.classList.remove( 'disabled' );
				}

				quantityInput.dispatchEvent(new Event('change', { bubbles: true }));

				if( isSimpleProduct ) self.simpleProductUpdatePrices( getProductWrap, quantityInput.value );
				if( isVariableProduct ) self.variableProductUpdatePrices( getProductWrap, quantityInput.value );

				if( isCartPage ) {
					self.updateCart();
				}
			});
		});
	},

		simpleProductUpdatePrices: function( product, qty ) {
			const self = this;

			if( ! product.querySelector( '.product-price-qty' ) ) {
				return false;
			}

			const realAmount =  parseFloat( product.querySelector( '.product-price-qty' ).getAttribute( 'data-amount' ) );
			const total = realAmount * qty;

			product.querySelector( '.product-price-qty span.price-number' ).classList.add( 'do-not-touch' );

			if( product.querySelector( 'bdi > span.price-number' ).length == 0 ) {
				return false;
			} 

			product.querySelectorAll( 'bdi > span.price-number' ).forEach(( item ) => {
				if( item.classList.contains( 'do-not-touch' ) ) {
					return;
				}

				item.innerHTML = total;
			});

			self.updateBookingModuleSale( total, qty );
		},
		
		variableProductUpdatePrices: function( product, qty ) {
			const self = this;

			if( ! product.querySelector( '.product-price-qty' ) ) {
				return false;
			}

			const realAmount =  parseFloat( product.querySelector( '.product-price-qty' ).getAttribute( 'data-amount' ) );
			const total = realAmount * qty;

			if( product.querySelector( 'bdi > span.price-number' ).length == 0 ) {
				return false;
			} 

			product.querySelectorAll( 'bdi > span.price-number' ).forEach(( item ) => {
				if( item.classList.contains( 'do-not-touch' ) ) {
					return;
				}

				item.innerHTML = total.toLocaleString( 'cs-CZ', { minimumFractionDigits: 0 } );
			});

			self.updateBookingModuleSale( total, qty );
		},

		updateBookingModuleSale: function( total, qty ) {
			const self = this;

			if( ! self.isBookingProduct ) {
				return false;
			}

			if( ! self.BMDiscounts ) {
				return false;
			}

			const discountEl = jQuery( '.aplicable-discount' );
			let applyDiscount = false;
			let discountType = [];

			self.BMDiscounts.forEach(function( item, key ){
				item.items.forEach(function( rule, key2 ){
					if( parseInt( qty ) >= parseInt( rule.from ) ) {
						applyDiscount = true;
						discountType = [ self.BMDiscounts[ key ][ 'append' ], self.BMDiscounts[ key ][ 'items' ][ key2 ][ 'discount' ] ];
					}
				});
			});

			if( applyDiscount ) {
				discountEl.removeClass( 'd-none' );
				discountEl.find( 'span' ).text( `${discountType[1]} ${discountType[0]}` );

				// console.log( total );

				return false;
			}

			discountEl.addClass( 'd-none' );
			discountEl.find( 'span' ).text( '' );
		},

		updateCart: function() {
			document.querySelector( '[name="update_cart"]' ).removeAttribute( 'disabled' );
		},

	loadProfileAddresses: function() {

		if( typeof pctUsrVars !== 'undefined' && pctUsrVars.hasOwnProperty('api_user_detail') ) {
			if( pctUsrVars.api_user_detail === null ) {
				return false;
			}

			// console.log(pctUsrVars.api_user_detail);
			let org_addresses = pctUsrVars.api_user_detail.organizationAddresses ?? false;
			let addresses = org_addresses ? org_addresses : pctUsrVars.api_user_detail.userAddresses;
			this.initializeAddressForm(addresses);
		}else {
			if( typeof profileVars == 'undefined' ) {
				return false;
			}

			profile.pctApiCall('GET', `/v1/profile/address/me`, "").then(addresses => {
				this.initializeAddressForm(addresses);
				this.fillAddress();
			}).catch(error => {
				console.error("Error fetching addresses:", error);
			});
		}
	},

	initializeAddressForm: function(addresses) {
		// console.log(addresses);
		self.addresses = addresses;
		const otherAddresses = document.querySelector('.js-otherAddresses');
		if(typeof otherAddresses === 'undefined' || otherAddresses === null) return;
		otherAddresses.innerHTML = '';

		if( typeof addresses === 'undefined' ) {
			jQuery( '.profile-form__user-addresses' ).addClass( 'd-none' );
			return false;
		}

		addresses.forEach(address => {
			const listItem = document.createElement('li');
			listItem.textContent = address.id;
			listItem.dataset.addressId = address.id;
			listItem.innerHTML = `<div><h3>${address.fullName}</h3><a href='#' class='js-fillAddress'>${pctVars.l18n.address.fill}</a></div><p>${address.street}, ${address.postalCode}, ${address.city}, ${address.country}</p></div>`

			listItem.dataset.address = JSON.stringify(address);
			otherAddresses.appendChild(listItem);
		});

		if (otherAddresses && otherAddresses.children.length === 0) {
			const li = document.createElement('li');
			li.className = 'empty';
			li.textContent = pctVars.l18n.address.no;
			otherAddresses.appendChild(li);
		}

		this.fillAddress();
	},

	fillAddress: function() {
		let fillAddresses = document.querySelectorAll('.js-fillAddress');
		// console.log("fillAddresses")
		// console.log(fillAddresses)
		if( fillAddresses.length ) {
			fillAddresses.forEach( fillButton => {
				fillButton.addEventListener('click', function(e) {
					e.preventDefault();

					const address = fillButton.closest( 'li' );

					const addressData = JSON.parse(address.dataset.address);

					// Split string to firstName and lastName
					const fullName = addressData.fullName.split(' ');
					const phone = addressData.phonePrefix + addressData.phoneNumber

					for (const key in addressData) {
						addressData[key] = (addressData[key] && addressData[key] !== 'undefined') ? addressData[key] : '';
					}

					document.querySelector(`.js-otherAddresses`).dataset.addressId = addressData.id;
					document.querySelector("#billing_first_name").value = fullName[0] || ''
					document.querySelector("#billing_last_name").value = fullName[1] || ''
					document.querySelector("#billing_email").value = addressData.contactEmail;
					document.querySelector("#billing_phone").value = phone;
					document.querySelector("#billing_address_1").value = addressData.street;
					document.querySelector("#billing_postcode").value = addressData.postalCode;
					document.querySelector("#billing_city").value = addressData.city;
					document.querySelector("#billing_country").value = addressData.country;
					document.querySelector("#billing_state").value = addressData.state;
					document.querySelector("#billing_company").value = addressData.companyName;
					document.querySelector("#billing_ic").value = addressData.ico;
					document.querySelector("#billing_dic").value = addressData.dic;


					for (const key in addressData) {
						// console.log(key + ": " +addressData[key])
					}

					self.openOtherAddressModal();
				});
			});
		}
	},

	checkBookingDate: function() {
		if (typeof booking_allowed_date === 'undefined') {
			return false;
		}
	
		const currentDate = new Date();
		currentDate.setHours(0, 0, 0, 0); // Strip time from current date
	
		const fromDate = booking_allowed_date.from ? new Date(booking_allowed_date.from) : null;
		if (fromDate) fromDate.setHours(0, 0, 0, 0); // Strip time from fromDate
	
		const toDate = booking_allowed_date.to ? new Date(booking_allowed_date.to) : null;
		if (toDate) toDate.setHours(0, 0, 0, 0); // Strip time from toDate
	
		const bookingElement = document.querySelector('.product-price-wrapper');
		const classtoAdd = 'd-none';
	
		if ((fromDate && currentDate < fromDate) || (toDate && currentDate > toDate)) {
			// Current date is before the 'from' date or after the 'to' date
			bookingElement.classList.add(classtoAdd);
		}
	}
};

export { woo };